import { analytics } from '@helpers/analytics'
import { useMemo } from 'react'
import styles from './styles.module.scss'

type CollectionCategoriesFiltersProps = {
  selectedCategory: string
  onSelect: (category: string) => void
  filtersCategories: string[]
}

export function CollectionCategoriesFilters({
  selectedCategory,
  onSelect,
  filtersCategories
}: CollectionCategoriesFiltersProps) {
  const categories = useMemo(
    () => ['all', ...filtersCategories],
    [filtersCategories]
  )

  const handleOnSelect = (category: string) => {
    analytics('Click', {
      category: 'Collection Page',
      label: `Category Collection filters - ${category}`,
      url: window.location.href
    })
    onSelect(category)
  }

  if (categories.length <= 1) return null

  return (
    <div className={styles.collectionCategoriesFilters__wrapper}>
      <ul className={styles.CollectionCategoriesFilters}>
        {categories.map(category => (
          <li key={category}>
            <button
              className={`${styles.CollectionCategoriesFilters__button} ${
                selectedCategory === category ? styles.selected : ''
              }`}
              type="button"
              onClick={() => handleOnSelect(category)}
            >
              {category}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
